<script setup>
import headerOne from '@/components/main/header/header.vue' // 页脚
import headerTow from '@/components/main/header/headerTow.vue' // 页脚


import { parseHeziyunData } from '@/utils/heziyunData' // 解析数据

const HeziyunData = ref(parseHeziyunData())

console.log(HeziyunData.value)

</script>

<template>
    <!-- 头部导航 - 1 -->
    <headerOne v-if="HeziyunData.theme.head == '1'"></headerOne>
    <!-- 头部导航 - 2 -->
    <headerTow v-if="HeziyunData.theme.head == '2'"></headerTow>
</template>